<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;">Catherine studied English in Southampton. She worked as a secretary for the foreign office in London and Tunis before returning to Southampton to teach.</p>
<p style="text-align: center;">Along the way there were jobs in a ballroom, a night club, a disco, cafés, hotels, and other diverse locations.</p>
<p style="text-align: center;">Catherine has travelled in the British Isles and the Middle East.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?077a49e1